import { useState, useEffect, createContext, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { requestTypes } from "../types/Context";
import { setAuthData } from "../utils/LocalStorageManager";
import jwt_decode from "jwt-decode";
import Urls from "../url/Urls";

const initialState = {
  isLoading: false,
  errorMsg: "",
  successMsg: "",
};

const AppContext = createContext<requestTypes>(initialState);
const AppProvider = ({ children, authData }: any) => {
  const [authInfo, setAuthInfo] = useState(authData);
  const [isLoading, setLoading] = useState(initialState.isLoading);
  const [errorMsg, setErrorMsg] = useState(initialState.errorMsg);
  const [successMsg, setSuccessMsg] = useState(initialState.successMsg);
  const [modalData, setModalData] = useState({
    modalOpen: false,
    modalType: "",
    modalObject: null,
  });

  const [authenticate, setAuthenticate] = useState(authData != null);
  const navigate = useNavigate();

  const loginProvider = async (loginData: any) => {
    try {
      //save login data in storage
      const authData = await setAuthData("authDUEAdminInfo", loginData);
      console.log(authData);
      if (!authData) {
        setAuthenticate(false);
        return;
      }
      const decodeToken: any = jwt_decode(authData?.tokenInfo?.access_token);
      const expiresAt = decodeToken?.exp;
      let valid = new Date().getTime() / 1000 < expiresAt;
      if (valid) {
        setAuthenticate(valid);
        setAuthInfo(authData);
        navigate("/", { replace: true });
        return;
      }
    } catch (error) {
      console.log(error);
    }
    //setAuthenticate(false);
    setAuthenticate(true);
  };

  const logoutProvider = async (e: any) => {
    //e.preventDefault();
    await setAuthData("authDUEAdminInfo", null);
    setAuthenticate(false);
    //@ts-ignore
    window.location.replace(Urls.base_login);
  };

  useEffect(() => {
    let time = 300000;
    let timeOutTimer = setTimeout(logoutProvider, time);
    const checkInactivity = () => {
      window.onclick = () => checkInactivity();
      window.onkeypress = () => checkInactivity();
      window.addEventListener("mousemove", checkInactivity);
      clearTimeout(timeOutTimer);
      timeOutTimer = setTimeout(logoutProvider, time);
    };
    checkInactivity();
  }, []);

  /**
   * resetErrorMsg
   */
  const resetErrorMsg = () => {
    setErrorMsg("");
  };

  /**
   * resetSuccessMsg
   */
  const resetSuccessMsg = () => {
    setSuccessMsg("");
  };

  const formContextValues: requestTypes = useMemo(
    () => ({
      authInfo,
      authenticate,
      isLoading,
      setLoading,
      errorMsg,
      setErrorMsg,
      successMsg,
      setSuccessMsg,
      modalData,
      setModalData,
      loginProvider,
      logoutProvider,
      resetErrorMsg,
      resetSuccessMsg,
    }),
    // eslint-disable-next-line
    [authInfo, authenticate, isLoading, errorMsg, successMsg, modalData]
  );

  return (
    <AppContext.Provider value={formContextValues}>
      {children}
    </AppContext.Provider>
  );
};

export { AppProvider };

export default AppContext;
